import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import { isScrollingDisabled } from '../../../ducks/UI.duck';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
  NamedLink,
  NamedRedirect,
  SupportChatWidget,
  Icon,
} from '../../../components';
import config from '../../../config';
import classNames from 'classnames';

import { helpContentFor } from '../HelpPage.helpers';

import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import css from './ArticlePage.module.css';

const Navigation = props => {
  const { topic, article } = props;
  return (
    <div className={css.navigation}>
      <ul className={css.navigationLinks}>
        <li className={classNames(css.navigationLinkActive, css.navigationLink)}>
          <NamedLink name="HelpPage">
            <FormattedMessage id="ArticlePage.toHelpPage" />
          </NamedLink>
        </li>
        <li>
          <Icon name="chevronRight" size={12} />
        </li>
        <li className={classNames(css.navigationLinkActive, css.navigationLink)}>
          <NamedLink name="TopicPage" params={{ topicId: topic.key }}>
            {topic.label}
          </NamedLink>
        </li>
        <li>
          <Icon name="chevronRight" size={12} />
        </li>
        <li className={css.navigationLink}>{article.label}</li>
      </ul>
    </div>
  );
};

const ArticlePageComponent = props => {
  const { intl, scrollingDisabled, params } = props;
  const helpConfig = helpContentFor(intl.locale);

  const topicId = params.topicId;
  const articleId = params.articleId;

  const topics = helpConfig.topics;
  const topic = topics.find(t => t.key === topicId);

  const article = helpConfig.articles.find(a => a.key === articleId);

  if (!topicId || !topic || !articleId || !article) {
    return <NamedRedirect name="NotFoundPage" />;
  }

  const schemaTitle = intl.formatMessage(
    {
      id: 'ArticlePage.schemaTitle',
    },
    {
      siteTitle: config.siteTitle,
      article: article.label,
    }
  );
  return (
    <Page
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ArticlePage',
        name: schemaTitle,
      }}
      scrollingDisabled={scrollingDisabled}
      currentPage="ArticlePage"
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.pageContent}>
            <div className={css.pageContentFlex}>
              <Navigation topic={topic} article={article} />
              <div className={css.pageContentHeader}>
                <h1 className={css.pageTitle}>{article.label}</h1>
              </div>
              <div className={css.articleContentHtml}>{article.Html}</div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
          <SupportChatWidget currentPage="ArticlePage" />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

ArticlePageComponent.propTypes = {
  intl: intlShape.isRequired,
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ArticlePage = compose(connect(mapStateToProps), injectIntl)(ArticlePageComponent);

export default ArticlePage;
